if (!Function.prototype.bind) {
  Function.prototype.bind = function (object) { //eslint-disable-line no-extend-native
    const self = this
    const slice = Array.prototype.slice
    const args = slice.call(arguments, 1)
    return function () {
      return self.apply(object, args.concat(slice.call(arguments)))
    }
  }
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/viewer/bindPolyfill.js